<template>
  <div class="body">
    <!--    <divider/>-->
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="tableLabel">编号</td>
          <td class="tdContent">{{ inspectionReport.no }}</td>
          <td class="tableLabel">供应商</td>
          <td class="tdContent">{{ inspectionReport.supplierName }}</td>
          <td class="tableLabel">关联单据</td>
          <td class="tdContent">{{ inspectionReport.billNo }}</td>
          <td class="tableLabel">物料编号</td>
          <td class="tdContent">{{ inspectionReport.materialNo }}</td>
        </tr>
        <tr>
          <td class="tableLabel">规格型号</td>
          <td class="tdContent">{{ inspectionReport.specification }}</td>
          <td class="tableLabel">物料名称</td>
          <td class="tdContent">{{ inspectionReport.materialName }}</td>
          <td class="tableLabel">检验等级</td>
          <td class="tdContent">{{ inspectionReport.checkLevel }}</td>
          <td class="tableLabel">AQL</td>
          <td class="tdContent">{{ inspectionReport.aql }}</td>
        </tr>
        <tr>
          <td class="tableLabel">检验数量</td>
          <td class="tdContent">{{ inspectionReport.inspectionQuantity }}</td>
          <td class="tableLabel">不良数量</td>
          <td class="tdContent">{{ inspectionReport.badQuality }}</td>
          <td class="tableLabel">检验结果</td>
          <td class="tdContent">
            <el-switch
                v-model="inspectionReport.inspectionResult1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="OK"
                :active-value="true"
                inactive-text="NG"
                :inactive-value="false" disabled/>
          </td>
          <td class="tableLabel">制单时间</td>
          <td class="tdContent">{{ inspectionReport.createdTime }}</td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tdContent" colspan="8">{{ inspectionReport.note }}</td>
        </tr>
        <tr>
          <td class="tableLabel">处理方式</td>
          <td class="tdContent" v-if="disableApplicationType">
            {{ constant.purchaseNgSolutionType[inspectionReport.applicationType] }}
          </td>
          <td class="tdContent" v-else>
            <el-select v-model="inspectionReport.applicationType" style="width: 100px;">
              <el-option v-for="item in solutionTypes" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </td>
          <td class="tableLabel">处理类型</td>
          <td class="tdContent" v-if="disableApplicationType">
            {{ constant.purchaseNgSolutionSubType[inspectionReport.applicationSubType] }}
          </td>
          <td class="tdContent" v-else>
            <el-select v-model="inspectionReport.applicationSubType" style="width: 100px;">
              <el-option v-for="item in solutionSubTypes" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </td>
          <td class="tableLabel">处理描述</td>
          <td class="tdContent" v-if="disableApplicationType" colspan="3">
            {{ inspectionReport.applicationTypeDesc }}
          </td>
          <td class="tdContent" v-else colspan="3">
            <el-input type="textarea" v-model="inspectionReport.applicationTypeDesc"/>
          </td>
        </tr>
        <tr v-if="showSolution">
          <td class="tableLabel">描述</td>
          <td class="tdContent" colspan="8" v-if="disableSolution">
            {{ inspectionReport.applicationNote }}
          </td>
          <td class="tdContent" colspan="8" v-else>
            <el-input type="textarea" v-model="inspectionReport.applicationNote"/>
          </td>
        </tr>
        <tr v-if="showFinSolution">
          <td class="tableLabel">采购财务描述</td>
          <td class="tdContent" colspan="8" v-if="disableFinSolution">
            {{ inspectionReport.applicationFinNote }}
          </td>
          <td class="tdContent" colspan="8" v-else>
            <el-input type="textarea" v-model="inspectionReport.applicationFinNote"/>
          </td>
        </tr>
        <tr v-if="showSolution1">
          <td class="tableLabel">结果</td>
          <td class="tdContent" colspan="8" v-if="disableSolution1">
            {{ inspectionReport.applicationSolution }}
          </td>
          <td class="tdContent" colspan="8" v-else>
            <el-select v-model="inspectionReport.applicationSolution" style="width: 100px;">
              <el-option value="入库"/>
              <el-option value="退货"/>
            </el-select>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 10px;">
      <el-table
          height="420"
          :data="inspectionReport.resultVOS"
          border>
        <!--          <el-table-column prop="inspectionItemNo" width="90" label="检验编号"/>-->
        <el-table-column prop="inspectionCategory" width="60" label="类型"/>
        <el-table-column prop="inspectionItemName" width="140" label="检验名称"/>
        <el-table-column prop="inspectionStandard" width="140" label="检验标准"/>
        <el-table-column prop="standardValue" label="标准值"/>
        <el-table-column prop="maxValue" label="最大值"/>
        <el-table-column prop="minValue" label="最小值"/>
        <el-table-column prop="value1" width="90" label="检验值"/>
        <el-table-column prop="value2" width="90" label="检验值"/>
        <el-table-column prop="value3" width="90" label="检验值"/>
        <el-table-column prop="value4" width="90" label="检验值"/>
        <el-table-column prop="value5" width="90" label="检验值"/>
        <el-table-column prop="inspectionResult" width="s0" label="检验结果">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.inspectionResult"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="OK"
                :active-value="true"
                inactive-text="NG"
                :inactive-value="false" disabled/>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionResultDesc" align="left" label="检验描述" width="200"/>
      </el-table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        附件
      </div>
      <!--      <upload-file-->
      <!--          ref="upload" v-if="showEngeUpload"-->
      <!--          :show-file-list="false"-->
      <!--          :auth-index="192"-->
      <!--          style="text-align: right;margin-top: 2px;"-->
      <!--          @upload-success="uploadSuccess"/>-->
      <el-table ref="payData1" border :data="inspectionReport.photos">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="photoPath" align="left" label="名称">
          <template slot-scope="scope">
            <a @click="downLoad(scope.row)">{{ scope.row.photoPath }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="left" label="创建人" width="100"/>
        <el-table-column prop="createTime" align="left" label="创建时间" width="140"/>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
import HandleDetail from "@/views/workFlow/HandleDetail";
import constant from "@/util/constant";
import UploadFile from "@/components/UploadFile";
import loginUtil from "@/util/loginUtil";

export default {
  // name: "PurchaseNgApplicationPreview",
  components: {HandleDetail, UploadFile},
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      billId: "",
      billType: "16",
      sequId: "",
      constant,
      nodeId: "",
      userId: 0,
      isHidden: false,
      disableApplicationType: false,
      disableSolution: false,
      showSolution: false,
      disableFinSolution: false,
      showFinSolution: false,
      disableSolution1: false,
      showSolution1: false,
      solutionTypes: constant.toSelect(constant.purchaseNgSolutionType),
      solutionSubTypes: constant.toSelect(constant.purchaseNgSolutionSubType),
      purchaseNgSolutionTypeName: "",
      purchaseNgSolutionSubTypeName: "",
      disableCostPrice: false,
      inspectionReport: {
        supplierName: "",
        pkId: 0,
        no: "",
        billNo: "",
        billType: 10,
        inspectionTemplateId: 0,
        inspectionTemplateName: "",
        billTypeName: "",
        materialNo: "",
        materialName: "",
        specification: "",
        note: "",
        createdTime: "",
        inspectionResult1: "",
        resultVOS: [],
        photos: [],
        drawFilePath: "",
        templateExist: 1,
        applicationType: 10,
        applicationSubType: 10,
        applicationTypeDesc: "",
        applicationNote: "",
        applicationFinNote: "",
        applicationSolution: "",
        attachments: [],
        details: [],
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.query.billId) {
          this.billId = val.query.billId;
          this.billType = val.query.billType;
          this.sequId = val.query.sequId;
          this.userId = loginUtil.getUserId();
          this.getData(val.query.billId);
          this.getNodeValue();
        }
      },
    },
    params: {
      handler() {
        this.doApprove();
      },
    },
  },
  methods: {
    getData() {
      this.$emit("loading-status", {"loading": true});
      this.$http
          .get("basic", `purchaseQualityApplications/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.inspectionReport = resp.data;
            if (this.inspectionReport.applicationSolution) {

            } else {
              this.inspectionReport.applicationSolution = "入库";
            }
          });
    },

    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },

    getNodeValue() {
      let params = {
        billType: this.billType,
        billId: this.billId,
        sequId: this.sequId,
      };
      this.$http.get("basic", "applications/approve", params).then((resp) => {
        this.nodeId = resp.data.nodeId;
        console.log(this.nodeId);
        this.initNode();
        this.checkNode();
      });
    },

    initNode() {
      this.disableApplicationType = true;
      this.disableSolution = false;
      this.showSolution = false;
      this.showFinSolution = false;
      this.disableFinSolution = true;
      this.showSolution1 = false;
      this.disableSolution1 = true;
    },

    checkNode() {
      //采购品质审核
      if (this.nodeId == "QmPurcApprove") {
        this.disableApplicationType = false;
      }

      if (this.nodeId != "QmPurcApprove") {
        this.showSolution = true;
      }

      if (["QmPurcApprove", "GeneralApprove"].includes(this.nodeId)) {
        this.disableSolution = true;
      }

      if (this.nodeId == "PurcFinaApprove") {
        this.showFinSolution = true;
        this.disableFinSolution = false;
      }

      if (this.nodeId == "GeneralApprove") {
        this.disableSolution1 = false;
        this.showSolution1 = true;
      }

    },

    changeSubType() {
      this.inspectionReport.applicationSubType = "";
      if (this.subTypeList) {
        this.inspectionReport.applicationSubType = this.subTypeList.join(",");
      }
    },

    doApprove() {
      let approveVar = "";
      //采购审核
      if (this.nodeId == "QmPurcApprove") {
        let varList = [];
        varList.push("ApplicationType#" + this.inspectionReport.applicationType);
        varList.push("ApplicationSubType#" + this.inspectionReport.applicationSubType);
        if (varList.length > 0) {
          approveVar = varList.join("|");
        }
      }

      // if (["QmPurcApprove", "QmGeneralApprove"].includes(this.nodeId)) {
      //   this.updateBill();
      // }

      let billParam = [];
      let params = {
        billId: parseInt(this.billId),
        billType: parseInt(this.billType),
        sequId: parseInt(this.sequId),
        actionType: this.params.actionType,
        approveNote: this.params.approveNote,
        untreadedFlowId: this.params.untreadedFlowId,
        transferTo: this.params.transferTo,
        approveVar: approveVar,
        billParam: JSON.stringify(billParam),
      };
      this.$emit("loading-status", {loading: true});
      this.$http
          .post("basic", "applications/doApprove", params)
          .then((resp) => {
            this.$emit("loading-status", {loading: false});
            if (resp.success) {
              this.updateBill();
              this.$message.success("保存成功");
              // if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
              //   this.updateHandle();
              // }
              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/PurchaseNgApplication",
              });
            }
          })
          .catch(() => {

            this.$emit("loading-status", {loading: false});
          });
    },

    updateBill() {
      this.$http.post("basic", "purchaseQualityApplications/save", this.inspectionReport)
          .then(() => {
          })
          .catch(() => {
          });
    },

    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
          creatorId: loginUtil.getUserId(),
          creatorName: loginUtil.getName(),
        };
        this.inspectionReport.attachments.push(params);
      }
    },

  },
};
</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
